/* Toca dos Lobos — theme.js (vanilla, no deps)
   Drawers, AJAX cart, qty steppers, scroll reveal. */
(function () {
  "use strict";

  const money = (cents) =>
    (window.Shopify && Shopify.formatMoney
      ? Shopify.formatMoney(cents, window.themeMoneyFormat)
      : "€" + (cents / 100).toFixed(2));

  /* ---------- Drawers ---------- */
  const openDrawer = (id) => {
    const d = document.getElementById(id);
    if (!d) return;
    d.classList.add("is-open");
    d.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
  };
  const closeDrawers = () => {
    document.querySelectorAll(".drawer.is-open").forEach((d) => {
      d.classList.remove("is-open");
      d.setAttribute("aria-hidden", "true");
    });
    document.body.style.overflow = "";
  };

  document.addEventListener("click", (e) => {
    const opener = e.target.closest("[data-drawer-open]");
    if (opener) {
      e.preventDefault();
      openDrawer(opener.getAttribute("data-drawer-open"));
    }
    if (e.target.closest("[data-drawer-close]") || e.target.classList.contains("drawer__overlay")) {
      closeDrawers();
    }
    const aboutLink = e.target.closest('a[href$="#sobre-nos"]');
    if (aboutLink && !e.defaultPrevented && e.button === 0 &&
        !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey) {
      // Unlock the page before scrolling from the mobile menu.
      if (aboutLink.closest('#mobile-nav')) closeDrawers();
      const target = document.getElementById('sobre-nos');
      const destination = new URL(aboutLink.href, location.href);
      const samePage = destination.origin === location.origin &&
        destination.pathname.replace(/\/+$/, '') === location.pathname.replace(/\/+$/, '');
      if (target && samePage) {
        e.preventDefault();
        // Keep development-preview and locale query parameters; do not reload the page.
        if (location.hash !== '#sobre-nos') history.pushState(null, '', '#sobre-nos');
        target.focus({ preventScroll: true });
        target.scrollIntoView({
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start'
        });
      }
    }
  });
  document.addEventListener("keydown", (e) => {
    // Let the top-layer hero dialog consume Escape without closing a drawer behind it.
    if (e.key === "Escape" && !document.querySelector("[data-hero-video-dialog][open]")) closeDrawers();
  });

  /* ---------- Cart (AJAX) ---------- */
  async function fetchCart() {
    const r = await fetch("/cart.js");
    return r.json();
  }

  function renderCart(cart) {
    document.querySelectorAll("[data-cart-count]").forEach((el) => {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
    const body = document.querySelector("[data-cart-body]");
    const totalEl = document.querySelector("[data-cart-total]");
    if (totalEl) totalEl.textContent = money(cart.total_price);
    if (!body) return;

    if (!cart.items.length) {
      body.innerHTML =
        '<p class="muted center" style="padding:2rem 0">A sua toca está vazia. Vamos explorar?</p>';
      return;
    }
    body.innerHTML = cart.items
      .map(
        (it) => `
      <div class="cart-line" data-key="${it.key}">
        <img class="cart-line__img" src="${it.image ? it.image.replace(/(\.[^.]+)$/, "_120x$1") : ""}" alt="" loading="lazy">
        <div>
          <a class="cart-line__title" href="${it.url}">${it.product_title}</a>
          ${it.variant_title ? `<div class="cart-line__meta">${it.variant_title}</div>` : ""}
          <div class="qty" style="margin-top:.5rem">
            <button data-qty="-" data-key="${it.key}" aria-label="Diminuir">–</button>
            <input value="${it.quantity}" data-key="${it.key}" inputmode="numeric" aria-label="Quantidade">
            <button data-qty="+" data-key="${it.key}" aria-label="Aumentar">+</button>
          </div>
        </div>
        <div style="text-align:right">
          <div class="cart-line__title">${money(it.final_line_price)}</div>
          <button class="link-arrow" data-remove="${it.key}" style="font-size:.8rem;color:var(--grey)">Remover</button>
        </div>
      </div>`
      )
      .join("");
  }

  async function changeLine(key, quantity) {
    const r = await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity }),
    });
    renderCart(await r.json());
  }

  document.addEventListener("click", async (e) => {
    const add = e.target.closest("[data-add-to-cart]");
    if (add) {
      e.preventDefault();
      const form = add.closest("form");
      const id = form ? form.querySelector('[name="id"]').value : add.dataset.addToCart;
      const qty = form && form.querySelector('[name="quantity"]') ? form.querySelector('[name="quantity"]').value : 1;
      add.classList.add("is-loading");
      await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id, quantity: qty }),
      });
      add.classList.remove("is-loading");
      renderCart(await fetchCart());
      openDrawer("cart-drawer");
    }
    const step = e.target.closest("[data-qty]");
    if (step) {
      const input = step.parentElement.querySelector("input");
      let v = parseInt(input.value, 10) || 1;
      v = step.dataset.qty === "+" ? v + 1 : Math.max(0, v - 1);
      if (step.dataset.key) changeLine(step.dataset.key, v);
      else input.value = Math.max(1, v);
    }
    const rm = e.target.closest("[data-remove]");
    if (rm) changeLine(rm.dataset.remove, 0);
  });

  document.addEventListener("change", (e) => {
    const input = e.target.closest('.qty input[data-key]');
    if (input) changeLine(input.dataset.key, Math.max(0, parseInt(input.value, 10) || 0));
  });

  /* ---------- Scroll reveal ---------- */
  const io =
    "IntersectionObserver" in window
      ? new IntersectionObserver(
          (entries) => {
            entries.forEach((en) => {
              if (en.isIntersecting) {
                en.target.classList.add("in");
                io.unobserve(en.target);
              }
            });
          },
          { rootMargin: "0px 0px -10% 0px" }
        )
      : null;
  const initReveal = (root = document) =>
    root.querySelectorAll(".reveal:not(.in)").forEach((el) => (io ? io.observe(el) : el.classList.add("in")));

  /* ---------- Product variants ---------- */
  const productFormListeners = new WeakMap();
  function initProductForm(form) {
    if (productFormListeners.has(form)) return;
    const json = form.querySelector("[data-variant-json]");
    if (!json) return;
    let variants = [];
    try { variants = JSON.parse(json.textContent); } catch (_) { return; }
    const select = form.querySelector("[data-variant-select]");
    const section = form.closest("[data-product-section]");
    const priceEl = section && section.querySelector("[data-price]");
    const submit = form.querySelector("[data-add-to-cart]");

    const selectedOptions = () =>
      Array.from(form.querySelectorAll(".product__option")).map((opt) => {
        const checked = opt.querySelector('input[type="radio"]:checked');
        return checked ? checked.value : null;
      });

    function update() {
      const chosen = selectedOptions();
      const match = chosen.length
        ? variants.find((v) => v.options.every((o, i) => o === chosen[i]))
        : variants[0];

      form.querySelectorAll(".swatch").forEach((s) => {
        const input = s.querySelector("input");
        s.classList.toggle("is-selected", input && input.checked);
      });

      if (!match) return;
      if (select) select.value = match.id;

      if (priceEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          priceEl.innerHTML =
            '<span class="on-sale" style="color:var(--clay-text)">' + money(match.price) +
            '</span><del style="color:var(--grey);font-size:1.1rem;margin-left:.5rem">' + money(match.compare_at_price) + "</del>";
        } else {
          priceEl.textContent = money(match.price);
        }
      }

      if (match.featured_media || match.featured_image) {
        form.dispatchEvent(new CustomEvent("product:variant-media", {
          bubbles: true,
          detail: {
            mediaId: match.featured_media && match.featured_media.id,
            imageId: match.featured_image && match.featured_image.id,
          },
        }));
      }

      if (submit) {
        submit.disabled = !match.available;
        submit.innerHTML = match.available
          ? submit.dataset.labelOk || submit.innerHTML
          : "Esgotado";
      }
    }

    if (submit) submit.dataset.labelOk = submit.innerHTML;
    const onChange = (e) => {
      if (e.target.matches('input[type="radio"]')) update();
    };
    productFormListeners.set(form, onChange);
    form.addEventListener("change", onChange);
    update();
  }
  const initProductForms = (root) => root.querySelectorAll("[data-product-form]").forEach(initProductForm);
  initProductForms(document);

  // Editor HTML replacement does not reliably execute section script tags.
  // Load the media runtime once when adding a section to a page without it.
  function ensureProductMediaRuntime(root) {
    if (window.__tocaProductMediaInitialized || document.querySelector("[data-product-media-runtime]")) return;
    const source = root.querySelector("script[data-product-media-script]");
    if (!source) return;
    const script = document.createElement("script");
    script.src = source.src;
    script.dataset.productMediaRuntime = "";
    document.head.appendChild(script);
  }
  function ensureHeroVideoRuntime(root) {
    if (window.TocaHeroVideo) {
      window.TocaHeroVideo.init(root);
      return;
    }
    if (document.querySelector("script[data-hero-video-runtime]")) return;
    const source = root.querySelector("script[data-hero-video-script]");
    if (!source) return;
    const script = document.createElement("script");
    script.src = source.src;
    script.dataset.heroVideoRuntime = "";
    script.addEventListener("error", () => script.remove(), { once: true });
    document.head.appendChild(script);
  }
  document.addEventListener("shopify:section:load", (e) => {
    ensureProductMediaRuntime(e.target);
    ensureHeroVideoRuntime(e.target);
    initProductForms(e.target);
    initReveal(e.target);
  });
  document.addEventListener("shopify:section:unload", (e) => {
    if (io) e.target.querySelectorAll(".reveal").forEach((el) => io.unobserve(el));
    e.target.querySelectorAll("[data-product-form]").forEach((form) => {
      const listener = productFormListeners.get(form);
      if (listener) form.removeEventListener("change", listener);
      productFormListeners.delete(form);
    });
  });

  /* ---------- Init ---------- */
  document.addEventListener("DOMContentLoaded", () => {
    initProductForms(document);
    initReveal();
    fetchCart().then(renderCart).catch(() => {});
  });
})();
